import { root } from './Placeholder.styles'
import { IPlaceholder } from './Placeholder.types'

const Placeholder = (props: IPlaceholder) => (
  <div data-testid='placeholder' css={root(props)} />
)

export default Placeholder
